import { getDefaultConfig } from "@rainbow-me/rainbowkit";
import { defineChain } from "viem";
import { http } from "wagmi";

// Robinhood Chain (Arbitrum Orbit L2) — not shipped in viem/wagmi yet, so we
// define both networks ourselves. Explorer is a Blockscout instance.
//
// Canonical Multicall3, verified deployed on Robinhood Chain mainnet. Declaring
// it lets viem batch the stats reads into ONE call instead of 4 separate
// eth_calls — faster and far less likely to be throttled by the public RPC
// (whose rate-limiting was intermittently blanking the metrics panel).
const MULTICALL3 = "0xcA11bde05977b3631167028862bE2a173976CA11" as const;

export const robinhoodChain = defineChain({
    id: 4663,
    name: "Robinhood Chain",
    nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
    rpcUrls: {
        default: { http: ["https://rpc.mainnet.chain.robinhood.com"] },
    },
    blockExplorers: {
        default: {
            name: "Blockscout",
            url: "https://robinhoodchain.blockscout.com",
        },
    },
    contracts: {
        multicall3: { address: MULTICALL3 },
    },
});

export const robinhoodChainTestnet = defineChain({
    id: 46630,
    name: "Robinhood Chain Testnet",
    nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
    rpcUrls: {
        default: { http: ["https://rpc.testnet.chain.robinhood.com"] },
    },
    blockExplorers: {
        default: {
            name: "Blockscout",
            url: "https://explorer.testnet.chain.robinhood.com",
        },
    },
    contracts: {
        multicall3: { address: MULTICALL3 },
    },
    testnet: true,
});

const projectId = import.meta.env.VITE_WALLETCONNECT_PROJECT_ID ?? "00000000000000000000000000000000";

export const wagmiConfig = getDefaultConfig({
    appName: "Safe Piggy",
    appDescription: "Six earning paths, one piggy.",
    appUrl: "https://safepiggy.xyz",
    projectId,
    chains: [robinhoodChain, robinhoodChainTestnet],
    transports: {
        [robinhoodChain.id]: http("https://rpc.mainnet.chain.robinhood.com"),
        [robinhoodChainTestnet.id]: http("https://rpc.testnet.chain.robinhood.com"),
    },
    ssr: false,
});
